import { useNavigate } from 'react-router-dom';

export default function SubjectGuideSection() {
  const navigate = useNavigate();

  const features = [
    { icon: 'ri-bookmark-3-line', title: '계열별 핵심과목', desc: '계열 진학에 필수인 핵심과목 안내' },
    { icon: 'ri-list-check-3', title: '선택 구분', desc: '일반·진로·융합 선택과목 구분' },
    { icon: 'ri-graduation-cap-line', title: '대학별 권장', desc: '대학별 권장과목까지 안내' },
    { icon: 'ri-map-2-line', title: '3년 로드맵', desc: '고1~고3 선택과목 로드맵 제공' },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl overflow-hidden border border-accent-200">
          {/* Background image */}
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=High%20school%20subject%20selection%20guide%20with%20textbooks%20and%20curriculum%20chart%20on%20a%20clean%20wooden%20desk%2C%20warm%20amber%20and%20cream%20tones%2C%20books%20and%20notes%20neatly%20organized%2C%20soft%20natural%20light%2C%20educational%20flat%20illustration%2C%20cozy%20studious%20atmosphere&width=1200&height=400&seq=subject-guide-banner-01&orientation=landscape"
              alt="선택과목 추천 가이드"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/95 to-accent-500/10"></div>
          </div>

          <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-8 p-8 md:p-12">
            {/* Left: text */}
            <div>
              <span className="inline-block text-accent-600 text-sm font-semibold tracking-widest uppercase mb-3">
                선택과목 가이드
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                고등학교 선택과목 추천
              </h2>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 max-w-md">
                나의 계열과 희망 전공에 맞는 핵심과목·권장과목을 2022 개정 교육과정 기준으로 안내합니다.
                서울시교육청 선택과목 안내서를 완전 반영했어요.
              </p>

              {/* Features */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
                {features.map((f) => (
                  <div key={f.title} className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                      <i className={`${f.icon} text-accent-600 text-base`}></i>
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-foreground-950">{f.title}</div>
                      <div className="text-xs text-foreground-500">{f.desc}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  onClick={() => navigate('/subject-guide')}
                  className="whitespace-nowrap bg-accent-500 hover:bg-accent-600 text-white font-semibold px-6 py-3 rounded-lg transition-colors cursor-pointer text-sm"
                >
                  <i className="ri-book-open-line mr-2"></i>
                  선택과목 추천받기
                </button>
                <button
                  onClick={() => navigate('/career-test')}
                  className="whitespace-nowrap bg-background-50 hover:bg-background-100 text-foreground-700 font-semibold px-6 py-3 rounded-lg border border-background-300 transition-colors cursor-pointer text-sm"
                >
                  <i className="ri-compass-3-line mr-2"></i>
                  먼저 진로 탐색하기
                </button>
              </div>
            </div>

            {/* Right: highlight card */}
            <div className="flex items-center">
              <div className="w-full bg-background-50/80 backdrop-blur-sm border border-background-200 rounded-xl p-6">
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-accent-500 rounded-lg">
                    <i className="ri-book-open-line text-white text-sm"></i>
                  </div>
                  <span className="font-semibold text-foreground-950 text-sm">이렇게 안내해드려요</span>
                </div>
                <ol className="space-y-3">
                  {[
                    { num: '1', text: '내 계열 선택 (인문·사회·자연·공학 등 6개 계열)' },
                    { num: '2', text: '핵심과목 · 일반·진로·융합 선택과목 구분 안내' },
                    { num: '3', text: '과목별 관련 직업·학과 상세 정보 확인' },
                    { num: '4', text: '고1~고3 3년 선택과목 로드맵 제공' },
                  ].map((step) => (
                    <li key={step.num} className="flex items-start gap-3">
                      <span className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 text-xs font-bold flex-shrink-0">
                        {step.num}
                      </span>
                      <span className="text-sm text-foreground-700 leading-relaxed">{step.text}</span>
                    </li>
                  ))}
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}